import { GapReportView } from './GapReportView';

export function RateGapReportPage() {
  return (
    <GapReportView
      gapType="INTEREST_RATE"
      title="Interest-Rate Gap report"
      description="Repricing gap by horizon — shows interest-rate sensitivity of the balance sheet. Empty until a rate-gap engine writes calculations with gap_type='INTEREST_RATE'."
      accent="rate"
    />
  );
}
